import { motion } from "framer-motion";
import { maskLine, stagger } from "@/lib/anim";
import { ArrowUpRight } from "lucide-react";

export const CTA = () => {
  return (
    <section
      id="cta"
      className="relative overflow-hidden px-6 md:px-12 py-28 md:py-44"
      data-testid="cta-section"
    >
      <div className="aurora h-[26rem] w-[26rem] -top-24 left-1/4 bg-primary/30" aria-hidden />
      <div className="aurora h-[22rem] w-[22rem] bottom-0 right-1/4 bg-accent/25" aria-hidden />

      <motion.div
        variants={stagger(0.12)}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-80px" }}
        className="relative z-10 mx-auto max-w-4xl text-center"
      >
        <div className="mask-line mb-6">
          <motion.p
            variants={maskLine}
            className="text-xs uppercase tracking-[0.24em] font-semibold text-primary"
          >
            You are not alone
          </motion.p>
        </div>
        <h2
          className="font-serif font-light tracking-tight text-foreground text-4xl sm:text-6xl lg:text-7xl leading-[1.02] text-balance"
          data-testid="cta-headline"
        >
          <span className="mask-line">
            <motion.span variants={maskLine} className="block">
              You don&apos;t have to
            </motion.span>
          </span>
          <span className="mask-line">
            <motion.span variants={maskLine} className="block italic text-primary">
              carry it alone.
            </motion.span>
          </span>
        </h2>

        <motion.p
          variants={maskLine}
          className="mt-8 text-lg md:text-xl text-muted-foreground max-w-2xl mx-auto leading-relaxed"
        >
          KelCalm is here to make support reachable, private, and human — the moment you
          need it.
        </motion.p>

        <motion.div variants={maskLine} className="mt-10 flex justify-center">
          <a
            href="mailto:hello@kelcalm.org"
            data-testid="cta-button"
            className="group inline-flex items-center gap-2 rounded-full bg-primary px-8 py-4 text-base font-semibold text-primary-foreground hover:bg-primary/90 transition-colors duration-300"
          >
            Get in touch
            <ArrowUpRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default CTA;
